import { Observable } from 'rxjs';

import { constructUrl } from '../private/utils/httpParamsUtils';
import {
  IContactMailData,
  IContactMailResponse,
  IMailingApi,
  IMailingVersions,
  IPrivacyRequestData,
  IPrivacyRequestResponse,
  ITeamsRequestData,
  ITeamsRequestResponse,
} from '../private/mailing-api/mailing-api.interface';
import { Authorize, AuthLevel } from '../private/authorize.decorator';
import { IApiUrls, IHostsConfigs } from '../private/global.interface';
import {
  AxiosInstanceType,
  SlAxiosInstanceService,
} from '../private/services/sl-axios-instance.service';
import { SlApiContext } from '../private/api-context';
import { Service, Container } from '../../symphony';

@Service()
export class MailingApi implements IMailingApi {
  private environmentUrl: string;

  private versions: IMailingVersions;

  private axiosInstance: AxiosInstanceType;

  constructor() {
    this.environmentUrl = (
      Container.take('global', 'envUrl') as IApiUrls
    ).mailingApiHost;
    this.versions = (
      Container.take('global', 'hostsConfigs') as IHostsConfigs
    )?.mailingApi?.version;

    this.axiosInstance = Container.take(
      SlApiContext,
      SlAxiosInstanceService,
    ).axios;
  }

  @Authorize(AuthLevel.public)
  public sendPrivacyRequest(
    payload: IPrivacyRequestData,
  ): Observable<IPrivacyRequestResponse> {
    return this.axiosInstance.post(
      constructUrl(
        this.environmentUrl,
        'api/email/dataprivacy',
        this.versions?.sendPrivacyRequest,
      ),
      payload,
    );
  }

  @Authorize(AuthLevel.public)
  public sendContactMail(
    payload: IContactMailData,
  ): Observable<IContactMailResponse> {
    return this.axiosInstance.post(
      constructUrl(
        this.environmentUrl,
        'api/email/contact',
        this.versions?.sendContactMail,
      ),
      payload,
    );
  }

  @Authorize(AuthLevel.public)
  public sendTeamsRequest(
    payload: ITeamsRequestData,
  ): Observable<ITeamsRequestResponse> {
    return this.axiosInstance.post(
      constructUrl(
        this.environmentUrl,
        'api/email/teams-request',
        this.versions?.sendTeamsRequest,
      ),
      payload,
    );
  }

  @Authorize(AuthLevel.public)
  public sendClassroomRequest(
    payload: any,
  ): Observable<any> {
    return this.axiosInstance.post(
      constructUrl(this.environmentUrl, 'api/email/classroom-request'),
      payload,
    );
  }
}

export * from '../private/mailing-api/mailing-api.interface';
